import { createSelector } from 'reselect';

import { BookmarkTagsType } from 'store/bookmarks/reducer.types.ts';
import { ReduxStore } from 'store/types';

function selectBookmarks(store: ReduxStore) {
    return store.bookmarks.getBookmarksRequest.data;
}

export const selectBookmarksByContentId = createSelector(
    selectBookmarks,
    (bookmarks) =>
        bookmarks.reduce(
            (acc, bookmark) => ({
                ...acc,
                [bookmark.contentId]: bookmark,
            }),
            {},
        ),
);

export const selectBookmarkByContentId = createSelector(
    selectBookmarks,
    (state: ReduxStore, contentId: string | undefined) => contentId,
    (bookmarks, contentId) =>
        bookmarks.find((bookmark) => bookmark.contentId === contentId),
);

export const selectNotCompletedBookmarkByContentId = createSelector(
    selectBookmarks,
    (state: ReduxStore, contentId: string | undefined) => contentId,
    (bookmarks, contentId) =>
        bookmarks.find(
            (bookmark) =>
                bookmark.contentId === contentId &&
                !bookmark.tags?.includes(BookmarkTagsType.COMPLETED),
        ),
);
